import React from 'react';
import { firestore } from '../../config/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

export default function Courses() {
  const [coursesData, setcoursesData] = useState([])
  const getcoursesFromFirestore = async () => {
    let arrayOfcourses = []
    try {
      const q = query(collection(firestore, 'courses'), where('status', '==', 'active'));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        arrayOfcourses.push(data)
      });
      setcoursesData(arrayOfcourses)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getcoursesFromFirestore()
  }, [])

  return (
    <>
      <Helmet>
        <title>Quran Courses, dive into Islam </title>
        <meta name="description" content="Courses: Discover our Quranic programs. From Tajweed to Tafseer, enrich your knowledge. Join us on your Quranic journey" />
        <link rel="canonical" href="https://www.ilmulquran.online/courses/" />
      </Helmet>
      <div>
        <h1 className="text-center  text-[#fffa8a] font-bold text-[48px] p-10 mt-12 underline">Courses</h1>
        <section className="text-gray-600 body-font">
          <div className="container px-5 py-18 mx-auto">
            <div className="flex flex-wrap -m-4">
              {coursesData.map((course) => {
                return (
                  < div className="p-4 w-[90%] md:w-1/3 mx-auto ">
                    <div className="h-full border-2  border-[#fffa8a] border-opacity-60 rounded-lg overflow-hidden">
                      <div className="p-6">
                        <h2 className="tracking-widest text-xs title-font opacity-50 font-medium text-[#fffa8a] mb-1">{course.category}</h2>
                        <h1 className="title-font text-2xl font-medium text-[#fffa8a] mb-3">{course.title}</h1>
                        <p className="leading-relaxed mb-3 text-[#fffa8a]">
                          {(() => {
                            const modifiedDescription = course.description && course.description.replace(/\\/g, " ");
                            return modifiedDescription && modifiedDescription.length > 50
                              ? `${modifiedDescription.slice(0, 75)}...`
                              : modifiedDescription;
                          })()}
                        </p>
                        <div className="flex items-center flex-wrap ">
                          <Link to={`/courses/${course.courseId}`}
                            className="text-indigo-500 inline-flex items-center md:mb-2 lg:mb-0">Read More
                            <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M5 12h14"></path>
                              <path d="M12 5l7 7-7 7"></path>
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>)
              })
              }
            </div>
          </div>
        </section >
      </div >
    </>
  );
}